// Supplemental cities — proper display names for city slugs that appear in the
// sitemap but are not yet covered by a country cities dataset. Without these, the
// Search Identity Engine falls back to a slug-derived name (which cannot restore
// diacritics, e.g. "kitzbhel" → "Kitzbhel") and the Identity Validator FAILs the page
// with DISPLAY_NAME_FROM_SLUG. Each entry here resolves one such name.
//
// slug matches the LIVE URL slug (so existing URLs keep resolving); `name` carries the
// correct proper spelling and diacritics. Growth of this list is expected as orphan
// cities surface in the validator's exceptions queue.

export const SUPPLEMENTAL_CITIES = [
  { slug: 'kitzbhel',                 name: 'Kitzbühel',                group: 'austria', regionSlug: 'tyrol' },
  { slug: 'st-christoph-am-arlberg',  name: 'St. Christoph am Arlberg', group: 'austria', regionSlug: 'tyrol' },
];
